import { render } from "./ReserveAVehicle.vue?vue&type=template&id=631c5d5e&lang=true"
import script from "./ReserveAVehicle.vue?vue&type=script&lang=js"
export * from "./ReserveAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/ReserveAVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631c5d5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631c5d5e', __exports__)) {
    api.reload('631c5d5e', __exports__)
  }
  
  module.hot.accept("./ReserveAVehicle.vue?vue&type=template&id=631c5d5e&lang=true", () => {
    api.rerender('631c5d5e', render)
  })

}


export default __exports__